import * as React from "react";
const SvgBatch24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 23,
        height: 22,
        fill: "black",
        viewBox: "0 0 23 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "#000",
      fillRule: "evenodd",
      d: "M22.412 5.94 11.47 0l-.009.016-.005-.01L.53 5.94l.004.008v2.055h.014l1.921 1.043-1.96 1.063H.5v1.774h.005l2.16 1.165-2.157 1.169H.5v1.773h.005l10.998 5.933.004-.007.005.007L22.44 15.99l-.005-.009h.003v-1.773h-.008l-2.139-1.159 2.15-1.166-.006-.01h.003V10.1h-.008l-1.95-1.057 1.913-1.039h.017v-2.06l.002-.004Zm-4.217 8.247-6.684 3.628-.004-.007-.004.007-6.734-3.633-1.697.92 8.432 4.55 8.38-4.55-1.69-.915ZM3.072 10.994l1.493-.81 6.901 3.748.004-.008.004.008 6.91-3.751 1.5.813-8.38 4.55-8.432-4.55ZM20.11 6.967l-8.64-4.692-8.64 4.692 8.64 4.691 8.64-4.691Z",
      clipRule: "evenodd"
    })
  );
export default SvgBatch24Px;
